/* eslint-disable */
export enum authLocalisationKeys {
  EMAIL = 'EMAIL',
  PASSWORD = 'PASSWORD', // NOSONAR
  LOGIN = 'LOGIN',
  LOGOUT_CONFIRM = 'LOGOUT_CONFIRM',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  PASSWORD_LENGTH_ERROR = 'PASSWORD_LENGTH_ERROR',
  EMPTY_LOGIN = 'EMPTY_LOGIN',
  EMPTY_PASSWORD = 'EMPTY_PASSWORD',
  LOGIN_LABEL = 'LOGIN_LABEL',
  PASS_LABEL = 'PASS_LABEL',
  SUBMIT = 'SUBMIT',
  RESET = 'RESET',
  CHOOSE_CUSTOMER = 'CHOOSE_CUSTOMER',
  ACCESS_DENIED = 'ACCESS_DENIED',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SMTH_HAPPEN = 'SMTH_HAPPEN'
}

export const enAuthLocalisationMessages = {
  [authLocalisationKeys.EMAIL]: `email`,
  [authLocalisationKeys.PASSWORD]: `password`, // NOSONAR
  [authLocalisationKeys.LOGIN]: `log in`,
  [authLocalisationKeys.LOGOUT_CONFIRM]: `Are you sure you want to logout?`,
  [authLocalisationKeys.INVALID_CREDENTIALS]: `Invalid credentials!`,
  [authLocalisationKeys.PASSWORD_LENGTH_ERROR]: `Password should be between 5-20 characters`,
  [authLocalisationKeys.EMPTY_LOGIN]: `Login required`,
  [authLocalisationKeys.EMPTY_PASSWORD]: `Password required`,
  [authLocalisationKeys.LOGIN_LABEL]: `Email address`,
  [authLocalisationKeys.PASS_LABEL]: `Password`,
  [authLocalisationKeys.SUBMIT]: `Submit`,
  [authLocalisationKeys.RESET]: `Clear`,
  [authLocalisationKeys.CHOOSE_CUSTOMER]: `Choose customer`,
  [authLocalisationKeys.ACCESS_DENIED]: `Access denied`,
  [authLocalisationKeys.SESSION_EXPIRED]: `Session expired`,
  [authLocalisationKeys.SMTH_HAPPEN]: `An unexpected error occurred. Please report this to Support.`
}
